import { Proxy } from '@skinsoft/network'
import { NETWORK_ERROR } from '@skinsoft/network/src/fetch'
import { EMPTY, identity, iif, of, throwError, timer } from 'rxjs'
import { catchError, delay, map, retryWhen, scan, switchMap } from 'rxjs/operators'

function startExport(
    itemId: string,
    language: string,
    printableReportId: string,
    shouldBeRotated: boolean,
) {
    return new Proxy().fetch(`/export/printable-report`, undefined, 'POST', {
        indexSearchRequest: { page: 0, pageSize: 1 },
        language: language,
        searchMode: 'selectedResults',
        selectedIds: [itemId],
        printableReportId: printableReportId,
        pdfPagination: false,
        fileName: '',
        numberLabelPerObject: 1,
        shouldBeRotated
    })
}

function repeatedlyCheckExportStatus(exportId: string) {
    return of(true).pipe(
        map(() => new Proxy().fetch('/export/getStatus', { exportId })),
        switchMap(identity),
        map(x =>{
            if (x === 'completed') {
                return x
            }
            throw new Error('Export not complete')
        }),
        retryWhen(errors =>
                errors.pipe(
                    scan(errorCount => {
                        if (errorCount >= 5) {
                            throw new Error('Export not completed after 5 tries')
                        }

                        return errorCount + 1
                    }, 0),
                    delay(500),
                ),
            ),
        map(() => exportId)
    )
}

function getExport(exportId: string) {
    return new Proxy().fetch('/export/getExport', { exportId }, 'GET', undefined, false, false, true).pipe(
        map(stream => new Blob([stream], {type: 'application/pdf'}))
    )
}

export function exportItem(itemId: string, language: string, printableReportId: string, shouldBeRotated: boolean) {
    return startExport(itemId, language, printableReportId, shouldBeRotated).pipe(
        switchMap(repeatedlyCheckExportStatus),
        switchMap(getExport)
    )
}